import { render, staticRenderFns } from "./order-goods-info.vue?vue&type=template&id=9fd5a6f2&scoped=true&"
import script from "./order-goods-info.vue?vue&type=script&lang=js&"
export * from "./order-goods-info.vue?vue&type=script&lang=js&"
import style0 from "./order-goods-info.vue?vue&type=style&index=0&id=9fd5a6f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fd5a6f2",
  null
  
)

export default component.exports